module.exports = __webpack_public_path__ + "static/img/offlinebanner.ca2e6a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/offlinebanner.png
// module id = 6DZ2
// module chunks = 0